import React from 'react';

const JS_Graphics = () => {
  return (
    <div >
      <h1>JS_Graphics</h1>
      <p>Placeholder component for: "JS Graphics"</p>
    </div>
  );
};

export default JS_Graphics;
